import { tenantsService } from '../../services/tenant.service';

const initialState = () => ({
  tenants: [],
  status: {
    error: null,
    pending: false,
    resolved: false,
    rejected: false,
  },
});

const state = initialState();

const actions = {
  getTenants({ commit }) {
    commit('GET_TENANTS');
    return tenantsService.getTenants().then(
      (response) => {
        commit('SUCCESS', response);
      },
      (error) => {
        commit('ERROR', error.response);
      },
    );
  },
  createTenant({ commit }, tenant) {
    commit('CRUD_TENANT');
    return tenantsService.createTenant(tenant).then(
      () => {
        commit('CRUD_SUCCESS');
      },
      (error) => {
        commit('ERROR', error.response);
        throw error;
      },
    );
  },
  updateTenant({ commit }, { tenantId, tenant }) {
    commit('CRUD_TENANT');
    return tenantsService.updateTenant({ tenantId, tenant }).then(
      () => {
        commit('CRUD_SUCCESS');
      },
      (error) => {
        commit('ERROR', error.response);
        throw error;
      },
    );
  },
};

const mutations = {
  GET_TENANTS(state) {
    state.status = {
      error: null,
      pending: true,
      resolved: false,
      rejected: false,
    };
    state.tenants = [];
  },
  CRUD_TENANT(state) {
    state.status = {
      error: null,
      pending: true,
      resolved: false,
      rejected: false,
    };
  },
  SUCCESS(state, tenants) {
    state.status = {
      ...state.status,
      pending: false,
      resolved: true,
    };
    state.tenants = tenants;
  },
  CRUD_SUCCESS(state) {
    state.status = {
      ...state.status,
      pending: false,
      resolved: true,
    };
  },

  ERROR(state, error) {
    state.status = {
      ...state.status,
      pending: false,
      rejected: true,
      error: error,
    };
  },
};

const getters = {
  tenants: (state) => state.tenants,

  // status
  error: (state) => state.status.error,
  pending: (state) => state.status.pending,
  rejected: (state) => state.status.rejected,
  resolved: (state) => state.status.resolved,
};

export const tenants = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
